import { render, staticRenderFns } from "./RziAuthorizationList.vue?vue&type=template&id=da4788da&scoped=true&"
import script from "./RziAuthorizationList.vue?vue&type=script&lang=js&"
export * from "./RziAuthorizationList.vue?vue&type=script&lang=js&"
import style0 from "./RziAuthorizationList.vue?vue&type=style&index=0&id=da4788da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4788da",
  null
  
)

export default component.exports